<template>
  <el-dialog
    :title="$t('addMapping.title')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item :label="$t('addMapping.configItem')" prop="domain">
        <el-select 
          v-model="form.domain" 
          :placeholder="$t('addMapping.selectConfigItem')"
          style="width:100%"
        >
          <el-option
            v-for="item in domains"
            :key="item.domain"
            :label="item.domainName"
            :value="item.domain"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addMapping.name')" prop="name">
        <el-input 
          v-model="form.name" 
          :placeholder="$t('addMapping.enterName')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('addMapping.key')" prop="mappingKey">
        <el-input 
          v-model="form.mappingKey" 
          :placeholder="$t('addMapping.enterKey')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('addMapping.value')" prop="value">
        <el-input 
          v-model="form.value" 
          :placeholder="$t('addMapping.enterValue')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('addMapping.remark')">
        <el-input
          type="textarea"
          :placeholder="$t('addMapping.enterRemark')"
          v-model="form.remark"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveMappingInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveMapping, listMappingDomains } from '@/api/dev/mappingApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddMapping',
  data() {
    return {
      dialogVisible: false,
      domains: [],
      form: {
        domain: 'DOMAIN.COMMON',
        name: '',
        mappingKey: '',
        value: '',
        remark: ''
      },
      rules: {
        domain: [
          { required: true, message: this.$t('addMapping.domainRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('addMapping.domainMaxLength'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('addMapping.nameRequired'), trigger: 'blur' },
          { min: 2, max: 50, message: this.$t('addMapping.nameLength'), trigger: 'blur' }
        ],
        mappingKey: [
          { required: true, message: this.$t('addMapping.keyRequired'), trigger: 'blur' },
          { min: 1, max: 100, message: this.$t('addMapping.keyLength'), trigger: 'blur' }
        ],
        value: [
          { required: true, message: this.$t('addMapping.valueRequired'), trigger: 'blur' },
          { min: 1, max: 100, message: this.$t('addMapping.valueLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.listAddMappingDomains()
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.form = {
        domain: 'DOMAIN.COMMON',
        name: '',
        mappingKey: '',
        value: '',
        remark: ''
      }
    },
    saveMappingInfo() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = {
            ...this.form,
            shopId: getShopId()
          }
          saveMapping(params).then(() => {
            this.$message.success(this.$t('addMapping.saveSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          }).catch(error => {
            this.$message.error(error.message)
          })
        }
      })
    },
    listAddMappingDomains() {
      listMappingDomains().then(response => {
        this.domains = response.data
      }).catch(error => {
        console.log('请求失败处理', error)
      })
    }
  }
}
</script>